import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";

export const addData = async (collectionKey, keyID, data) => {
    try {
        await setDoc(doc(db, collectionKey, keyID), data);
        console.log("Document successfully written!");
    } catch (error) {
        console.error("Error adding document: ", error);
    }
};

export const fetchDocument = async (collectionKey, keyID) => {
    try {
      const docRef = doc(db, collectionKey, keyID);
      const docSnap = await getDoc(docRef);
  
      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    }
};

export const grabData = async () => {
    // console.log("Grabbing data!");
    let data = window.sessionStorage.getItem("database");
    if (data) {
        data = JSON.parse(data);
    } else {
        data = await fetchDocument("glossary", "version1")
    }
    return data;
}